import React from 'react'
import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'

import * as TurnoService from 'services/turno.service'

const ValidationSchema = Yup.object().shape({
  idIsla: Yup.string().required()
})

const CambiarIslaModal = ({ history }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [mostrarModal, setMostrarModal] = React.useState(true)

  const formInitialValues = React.useMemo(
    () => ({
      idIsla: __adminContext._idIsla || ''
    }),
    [__adminContext]
  )

  const handleClose = React.useCallback(() => {
    setMostrarModal(false)
    history.push('/')
  }, [history])

  const submitHandler = async data => {
    await TurnoService.self
      .cambiarIsla(data)
      .then(() => {
        __zariContext.snack('success', 'Se ha cambiado de isla.')
        __adminContext.setIdIslaActiva(data.idIsla)
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  if (!__adminContext.estadoTurno) {
    return <></>
  }

  return (
    <Modal show={mostrarModal}>
      <Modal.Header>
        <Modal.Title>CAMBIAR ISLA</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.IdIslaFormGroup
                fIsSubmitting={isSubmitting}
                iTouched={touched.idIsla}
                iError={errors.idIsla}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit} disabled={isSubmitting}>
                Cambiar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(CambiarIslaModal)
